<template>
  <section class="p-2">
    <v-card>
      <OverlayPageVue :showOverlay="loaderOverlay" />
      <v-form ref="complincmanual" v-model="valid" lazy-validation>
        <v-card-title class="d-flex justify-space-between p-0 m-0">
          <div class="ps-2 headingFontsize">Manual Sanction Entry</div>
          <div>
            <bread-crumb :bread-crumbs="['Manual Sanction Entry']" />
          </div>
        </v-card-title>
        <v-divider class="p-0 m-0 primary--text"></v-divider>
        <v-row class="ms-1 me-1 mt-2" justify="center">
          <!-- <v-col cols="12" md="4" lg="4" xs="12">
            <label class="required labelFontsize my-0"> Type</label>
            <v-autocomplete
              v-model="complianceManagePost.vessel_type"
              :rules="typeRules"
              :items="vesselType"
              class="rounded"
              dense
              outlined
              placeholder="Type"
            ></v-autocomplete>
          </v-col> -->
          <v-col cols="12" md="4">
            <label class="labelFontsize required my-0">Name</label>
            <v-text-field
              v-model="complianceManagePost.name"
              dense
              outlined
              :rules="nameValidations"
              placeholder="Name"
              class="rounded"
            ></v-text-field>
          </v-col>
          <v-col cols="12" md="4">
            <label class="labelFontsize required my-0"> Country </label>
            <v-autocomplete
              v-model="complianceManagePost.country"
              dense
              outlined
              :items="countryOptions"
              :rules="countryRules"
              placeholder="Country"
              class="rounded"
            ></v-autocomplete>
          </v-col>
          <v-col cols="12" md="4" lg="4" xs="12">
            <label class="labelFontsize my-0">Address</label>
            <v-text-field
              v-model="complianceManagePost.address"
              class="rounded"
              dense
              outlined
              placeholder="Address"
            ></v-text-field>
          </v-col>
        </v-row>
        <v-row class="ms-1 me-1 mt-1" justify="center">
          <v-col cols="12" md="4">
            <label class="labelFontsize required my-0">ID Type</label>
            <v-autocomplete
              v-model="complianceManagePost.id_type"
              dense
              outlined
              :items="idTypeOptions"
              :rules="idType"
              placeholder="ID Type"
              class="rounded"
            ></v-autocomplete>
          </v-col>
          <v-col cols="12" md="4">
            <label class="labelFontsize required my-0">ID Number</label>
            <v-text-field
              v-model="complianceManagePost.id_number"
              dense
              outlined
              :rules="idnumberValidations"
              placeholder="ID Number"
              class="rounded"
            ></v-text-field>
          </v-col>
          <v-col cols="12" md="4" lg="4" xs="12">
            <label class="labelFontsize required my-0">Date of Birth</label>
            <v-text-field
              v-model="complianceManagePost.dob"
              class="rounded"
              dense
              :rules="DOBRules"
              outlined
              type="date"
              placeholder="Date of Birth"
            ></v-text-field>
          </v-col>
        </v-row>
        <v-row class="ms-1 me-1 mt-1" justify="center">
          <v-col cols="12" md="4">
            <label class="labelFontsize my-0">Contact Number</label>
            <v-text-field
              v-model="complianceManagePost.contact_number"
              dense
              outlined
              placeholder="Contact Number"
              class="rounded"
              prefix="+60"
              type="number"
              hide-spin-buttons
              :hint="'+60 xx xxx xxxx'"
            ></v-text-field>
          </v-col>
          <v-col cols="12" md="4">
            <label class="labelFontsize my-0">Father's Name</label>
            <v-text-field
              v-model="complianceManagePost.father_name"
              dense
              outlined
              placeholder="Father's Name"
              class="rounded"
            ></v-text-field>
          </v-col>
          <v-col cols="12" md="4">
            <label class="labelFontsize required my-0"> Data Source </label>
            <v-text-field
              v-model="complianceManagePost.data_source"
              dense
              :rules="datasourcRules"
              outlined
              placeholder="Data Source"
              class="rounded"
            ></v-text-field>
          </v-col>
        </v-row>
        <v-row class="ms-1 me-1 mt-1"> </v-row>
        <v-row class="ms-1 me-1 mt-1">
          <v-col class="">
            <label class="labelFontsize required my-0">Remarks</label>
            <v-textarea
              outlined
              name=""
              v-model="complianceManagePost.remarks"
              :rules="remarksValidations"
              :counter="remarksCounter"
              :error-messages="remarksErrors"
            ></v-textarea>
          </v-col>
          <v-col class="">
            <label class="labelFontsize required my-0">A.K.A</label>
            <v-textarea
              outlined
              name=""
              :rules="akaValidations"
              :counter="akaCounter"
              :error-messages="akaErrors"
            ></v-textarea>
          </v-col>
        </v-row>
        <v-row class="ms-1 me-1">
          <v-col cols="12" md="4" sm="4">
            <v-switch
              hide-details
              label="Is Active?"
              v-model="complianceManagePost.is_active"
            ></v-switch>
          </v-col>
        </v-row>
        <v-col cols="12" md="12">
          <v-row class="d-flex justify-end">
            <v-btn depressed 
              color="primary"
              small
              class="ma-2 mb-10 text-capitalize"
              width="120px"
              @click="saveData()"
            >
            <v-icon small class="me-2">mdi-content-save-check-outline</v-icon> Submit
            </v-btn>
            <v-btn depressed 
              small
              @click="cancel()"
              class="ma-2 text-capitalize"
              width="120px"
              color="primary"
              outlined
            >
              <!-- <v-icon dark> mdi-file-document-remove-outline </v-icon> -->
              <v-icon small class="me-2">mdi-close-circle-outline</v-icon> Cancel
            </v-btn>
          </v-row>
        </v-col>
      </v-form>
    </v-card>
  </section>
</template>

<script>
import alerts from "../../mixins/alerts";
import { findDatePrevious } from "@/utils/helper";
import { complianceManage } from "@/utils/validationCopy.js";
import BreadCrumb from "@/components/navigations/BreadCrumb.vue";
import { checkNumber } from "../../utils/contactNumber/formatNumber";
import commonService from "@/services/CommonService/commonService.js";
import OverlayPageVue from "@/utils/OverlayPage.vue";
import setupService from "@/services/SetupService/setupService.js";
export default {
  name: "Manual Sanction Entry",
  mixins: [alerts],
  components: {
    BreadCrumb,
    OverlayPageVue,
    
  },
  data: () => ({
    // vesselType: ["Individual", "Bussiness"],
    checkNumber,

    valid: true,
    countryOptions: [],
    idTypeOptions: [],
    show_overlay: false,
    isDobError: false,
    ...complianceManage,
    loaderOverlay: false,
    complianceManagePost: {
      vessel_type: "Individual",
      name: "",
      country: "",
      address: "",
      id_type: "",
      id_number: "",
      dob: null,
      contact_number: "",
      father_name: "",
      data_source: "MOF",
      remarks: "",
      is_active: null,
    },
    remarksValidations: [
      (value) => !!value || "Remarks is required",
      (value) =>
        (value && value.length <= 2000) ||
        "Remarks cannot exceed 2000 characters",
    ],
    remarksCounter: 0,
    remarksErrors: [],

    akaValidations: [
      (value) => !!value || "A.K.A is required",
      (value) =>
        (value && value.length <= 2000) ||
        "A.K.A cannot exceed 2000 characters",
    ],
    akaCounter: 0,
    akaErrors: [],
  }),
  mounted() {
    this.maxDate = findDatePrevious(new Date(), 18);
    this.minDate = findDatePrevious(new Date(), 70);
    this.getCountryList();
    this.getIdList('DOC');
  },

  watch: {
    "complianceManagePost.id_type"(value) {
      console.log("value", value);
    },
    "complianceManagePost.remarks"(value) {
      this.updateRemarksCounter(value);
    },
    "complianceManagePost.aka"(value) {
      this.updateAkaCounter(value);
    },
  },
  methods: {
    stoploader() {
      setTimeout(() => {
        this.loaderOverlay = false;
      }, 400);
    },
    updateRemarksCounter(value) {
      const maxLength = 2000;
      this.remarksCounter = `${value.length}/${maxLength}`;
    },
    updateAkaCounter(value) {
      const maxLength = 2000;
      this.akaCounter = `${value.length}/${maxLength}`;
    },
    cancel() {
      this.$refs.complincmanual.reset();

      // this.$refs.complincmanual.resetErrorBag();
    },
   
    
    async saveData() {
      const validate = this.$refs.complincmanual.validate();
      const Num_format = this.checkNumber(
        this.complianceManagePost.contact_number
      );
      this.complianceManagePost.contact_number = Num_format;
      if (validate) {
        this.loaderOverlay = true;
        try {
          const responseData = await setupService.PostMAnual(
            this.complianceManagePost
          );
          if (responseData && responseData.data.status_code === 200) {
            this.stoploader();
            this.showAlertSuccess(responseData.data.message);
         
           
          } 
          // else if (responseData.data.status_code == 401) {
          //   this.returnNewToken();
          //   this.saveData();
          // } 
          else {
            this.showAlertError(responseData.data.message);
            this.stoploader();
          }
        } catch (error) {
          console.log(error.response);
          this.showAlertError("Something went wrong please try again later.");
        }
      }
    },

    async getCountryList() {
      this.loaderOverlay = true;
      try {
        const response = await commonService.getdropdowns();
        if (response.data.status_code === 200) {
          this.countryOptions = response.data.data.map((i) => {
            return { text: i.country_name, values: i.name, id: i.iso3 };
          });
          console.log("CountryList", this.CountryList);
          this.stoploader();
        } 
        // else if (response.data.status_code === 401) {
        //   this.countryOptions = [];
        //   this.returnNewToken();
        //   this.getCountryList();
        //   this.stoploader();
        // }
         else {
          this.countryOptions == [];
          this.stoploader();
        }
      } catch (error) {
        this.countryOptions = [];
        this.stoploader();
        console.error(error);
      }
    },
    async getIdList(DOC) {
      this.loaderOverlay = true;
      try {
        const response = await commonService.getparameterdropdowns(DOC);
        if (response.data.status_code === 200) {
          this.idTypeOptions = response.data.data.map((i) => {
              return { text: i.value, values: i.value_code };
          });
          console.log("CountryList", this.CountryList);
          this.stoploader();
        }
        //  else if (response.data.status_code === 401) {
        //   this.idTypeOptions = [];
        //   this.returnNewToken();
        //   this.getIdList();
        //   this.stoploader();
        // }
         else {
          this.idTypeOptions == [];
          this.stoploader();
        }
      } catch (error) {
        this.idTypeOptions = [];
        this.stoploader();
        console.error(error);
      }
    },
  
  },
};
</script>

<style lang="scss" scoped>
@import "@/global.scss";
.required:after {
  content: " *";
  color: red;
}
</style>
